import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';
import PaginateKey from './PaginateKey';
import PaginateComponentStyles from './PaginateComponentStyles';
import fillArray from './utils/fill-array';

const Paginate = ({ current, pageCount }) => {
  let keys = [];

  if (current === 1) {
    const centerPages = fillArray(pageCount).splice(0, 3);

    keys = [...centerPages, pageCount];
  } else if (current === pageCount) {
    const centerPages = fillArray(pageCount).splice(-2, 2);

    keys = [1, ...centerPages];
  } else {
    keys = fillArray(pageCount).splice(current - 2, 3);

    if (!keys.includes(1)) keys.unshift(1);

    if (!keys.includes(pageCount)) keys.push(pageCount);
  }

  keys = uniq(keys);

  const showPrevious = current > 1;
  const showNext = current !== pageCount;
  const previousPage = current - 1;
  const nextPage = current + 1;

  return (
    <PaginateComponentStyles>
      <ul className="pagination">
        <PaginateKey content="‹ Previous Page" page={previousPage} show={showPrevious} />

        {keys.map((k, i) => {
          const isMatch = k + 1 === keys[i + 1];
          const isLastPage = k === pageCount;
          const isActive = current === k;

          return (
            <Fragment key={k}>
              <PaginateKey content={k} page={k} isActive={isActive} />
              {!isMatch && !isLastPage ? <li>...</li> : null}
            </Fragment>
          );
        })}
        <PaginateKey content="Next Page ›" page={nextPage} show={showNext} />
      </ul>
    </PaginateComponentStyles>
  );
};

Paginate.propTypes = {
  current: PropTypes.number,
  pageCount: PropTypes.number,
};

Paginate.defaultProps = {
  current: 1,
  pageCount: 1,
};

export default Paginate;
